const css = `.UFPvxW__elementSelectMenu.UFPvxW__active{border-left:2px solid var(--base-strokes-activated);border-radius:4px}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"active":"UFPvxW__active","elementSelectMenu":"UFPvxW__elementSelectMenu"};
